import * as Yup from "yup";
import { reverseShape } from "Helpers/reverse-shape";
import { email, fullName, postcode, fullContact, password, workingHours } from "Utils/validations";
import { validString } from "Components/shared/helpers/validations";

const CustomerLocationFormSchema = Yup.object().shape(
  reverseShape({
    customerID: Yup.string().required(),
    customerLocationName: Yup.string()
      .required()
      .test("reservedName", "reservedName", (value) => value != "Primary Address"),
    street1: Yup.string().max(100).required(),
    street2: Yup.string().max(100).optional(),
    postcode: Yup.string().when("country", { is: "MY", then: postcode.required() }),
    city: Yup.string().max(50).required(),
    state: Yup.string().max(50).required(),
    cityCode: Yup.string().max(50).optional(),
    stateCode: Yup.string().max(50).optional(),
    country: Yup.string()
      .matches(/^[a-zA-Z]{2}$/i)
      .required(),
    contactPerson: fullName.required(),
    emailAddress: email.required(),
    contactNo: fullContact.required(),
    handlingInstruction: validString.optional(),
    workingHours: Yup.array().of(workingHours).optional(),
  }),
);

export default CustomerLocationFormSchema;
